import { useQuery } from '@tanstack/react-query';
import useFetch from '../../hooks/use-fetch';
import { promotionsURL } from './promotions-api';
import { promotionsCacheKey } from './promotions-cache-keys';
export default function usePromotionsQuery({ config, keyProps, queryOptions = { retry: false } }) {
    const fetchWrapper = useFetch(config);
    return useQuery(Object.assign({ queryKey: promotionsCacheKey(keyProps), queryFn: () => {
            const { accountId, accountIdType } = keyProps;
            const params = new URLSearchParams({
                'cipher.accountId': accountId
            });
            if (accountIdType) {
                params.set('accountIdType', accountIdType);
            }
            return fetchWrapper(`${promotionsURL}?${params}`, {
                method: 'GET'
            });
        } }, queryOptions));
}
//# sourceMappingURL=promotions-query.js.map